import './App.css';

import { Header } from './containers/Header';
import { Home } from './containers/Home';

function App() {
  return (
    <div className="App">
      <Header />
      <Home />
    </div>
  );
}

export default App;
